import arriereBackoffice, {
  SortOrder,
  TaxFeeSorting,
} from '@avantstay/arriere-clients/dist/arriereBackoffice'

export const getBookingFeeCatalog = async () => {
  const page = await arriereBackoffice.queries.searchTaxes({
    __alias: 'getBookingFeeCatalog',
    __args: {
      pagination: { size: 1000, page: 1 },
      sortOrder: SortOrder.ascending,
      sortBy: TaxFeeSorting.name,
      isTax: false,
      enabled: true,
    },
    results: {
      id: true,
      name: true,
      archived: true,
      feeApplicationType: true,
      feeCalculationType: true,
    },
  })

  return page.results
}
